<template>
<div>
	<div v-if="isval" class="msg_box">
		<div class="box_aqa">
			<h3>很抱歉，您查看的新闻动态找不到了！</h3>
			<div class="aqa_zi">
				<p>您可以:</p>
				<div>1.检查刚才的输入</div>
				<div>2.去其他地方逛逛：<span class="lan" @click="xin.goUrl('/index')">首页</span></div>
			</div>
		</div>
	</div>
	<div v-else v-loading="loading" class="msg_box min_he400">
		<div></div>
		<div class="arrow_box clearfloat">
			<span class="arrow_ywz">您的位置：</span>
			<div class="arrow">
				<span class="to" @click="xin.goUrl('/index')">首页</span>
				<span class="el-icon-arrow-right"></span>
				<span class="to" @click="xin.goUrl('/journalism/'+newurl)">{{newin}}</span>
				<span class="el-icon-arrow-right"></span>
				<span class="topc">新闻动态详情</span>
			</div>
		</div>
		<p class="tech_title">[{{newin}}] {{newinfo.title}}</p>
		<div class="jour_box">
			<!-- <div class="jour_msg">
				<span class="msg_zi">发布者：{{newinfo.publisher}}</span>
				<span class="msg_zi">发布时间：{{newinfo.create_time}}</span>
				<span class="msg_zi">来源：{{newinfo.source}}</span>
			</div> -->
			<!-- <div class="jour_content">
				{{newinfo.subtitle}}
			</div>
			<div class="jour_content">
				<img :src="newinfo.images"/>
			</div> -->
			<div class="jour_content" v-html="newinfo.content">
			</div>
		</div>
		<p class="lan" v-if="newon" @click="gojourm(newon.id)">
			上一篇：{{newon.title}}
		</p>
		<p class="lan" v-if="newnext" @click="gojourm(newnext.id)">下一篇：{{newnext.title}}</p>
	</div>
</div>
</template>

<script>
	export default{
		data(){
			return{
				loading:true,
				isval:false,
				newinfo:{},//新闻详情
				newon:{},//上一篇
				newnext:{},//下一篇
				newin:'',
				newurl:'',
			}
		},
		created(){
			this.newfont(this.$route.query.nid);
		},
		watch:{
			$route(to,from){
				this.newfont(to.query.nid);
			}
		},
		methods:{
			async newfont(news_id){
				if(!news_id){
					this.isval = true;
					return;
				}
				this.loading = true;
				let {data} = await this.api.PostnewInfo({news_id});
				if(!data.info){
					this.isval = true;
					return;
				}
				this.newinfo = data.info;
				this.newon = data.on;
				this.newnext = data.next;
				if(data.info.type == 1){
					this.newin = '产品最新动态';
					this.newurl = 'new';
				}else if(data.info.type == 2){
					this.newin = '文献最新动态';
					this.newurl = 'product';
				}else if(data.info.type == 3){
					this.newin = '公司新闻';
					this.newurl = 'company';
				}
				this.loading = false;
			},
			gojourm(id){
				this.newon = {};
				this.newnext = {};
				this.xin.goUrl('/jourDetails?nid='+id);
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.jour_box{
		margin-bottom: 60px;
		.jour_msg{
			border-top: #666666 1px solid ;
			.msg_zi{
				margin-right: 40px;
				font-size: 20px;
				font-weight: 500;
				color: #333333;
				line-height: 50px;
			}
		}
	}
	
</style>
